// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hb-0";